import { Button } from "@svea/design-system-components-react";
import { SvgIcon, Text, useText } from "@sveabank/cc-common";

type Props = {
	handleOpenSignModal: () => void;
	isFetchingAgreement: boolean;
	isSigned: boolean;
	accepted?: boolean;
};

const CurrentSignerStatus = ({
	handleOpenSignModal,
	isFetchingAgreement,
	isSigned,
	accepted = true,
}: Props) => {
	const [t, texts] = useText();

	return (
		<div className="tablet:w-auto w-full">
			{accepted ? (
				isSigned ? (
					<div className="flex gap-4">
						<SvgIcon imageSrc="SIGN_DONE" height={24} />
						<Text italic>{t(texts.signPage.package.signed)}</Text>
					</div>
				) : (
					<Button
						type="button"
						variant="primary"
						onPress={handleOpenSignModal}
						isPending={isFetchingAgreement}
						width="full"
					>
						{t(texts.signPage.package.signAgreementButton)}
					</Button>
				)
			) : (
				<Text italic>{t(texts.signPage.package.notEligible)}</Text>
			)}
		</div>
	);
};

export default CurrentSignerStatus;
